
/// <reference path="ReconciliationEntryState.ts" />
/// <reference path="InvoiceLineReconciliationDataSource.ts" />

class LedgerAccountReconciliationViewController extends BaseTableViewController implements LedgerAccountReconciliationDataSourceDelegate
{
    static newInstance(): LedgerAccountReconciliationViewController {
        let vc = new LedgerAccountReconciliationViewController("ledger-account-reconciliation-view");
        vc.initWithResource("layout/ledgeraccount/LedgerAccountReconciliationView.html");

        return vc;
    }

    private entityComboBox:MUIComboBox = null;
    private statusComboBox:MUIComboBox = null;

    private calendarButton:MUIButton = null;
    private saveButton:MUIButton = null;

    private accountingEntryContainer:MUIView = null;
    private accountingEntryViewController:AccountingEntryViewController = null;

    private conceptFilterTextField:ColumnFilterTextField = null;
    private bankConceptFilterTextField:ColumnFilterTextField = null;

    // the column titles and the heads of the sections, per entity (invoices or bank movements)
    private invoiceTitlebar:MUIView = null;
    private bankTitlebar:MUIView = null;
    private invoiceHeaderTemplate:InvoiceSectionReconciliationHeader = null;
    private showingBankColumns = false;
    private bankHeaderTemplate:BankAccountReconciliationHeader = null;

    private _from_date_str:string = null;
    private _to_date_str:string = null;
    private _status_filter = ReconciliationStatusFilter.all;

    private columnFilterController:ColumnFilterController = null;

    private activeDataSource:any = null;
    private salesInvoiceLineDataSource:SalesInvoiceLineReconciliationDataSource = null;
    private purchaseInvoiceLineDataSource:PurchaseInvoiceLineReconciliationDataSource = null;
    private bankMovementDataSource:BankMovementReconciliationDataSource = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.columnFilterController = new ColumnFilterController();
        this.columnFilterController.initWithDelegate(this);

        this.entityComboBox = MUIOutlet(this, "entity-type-cb", "MUIComboBox");
        this.entityComboBox.setOnChangeAction(this, function(this:LedgerAccountReconciliationViewController, control:MUIComboBox, value:string){
            switch(value) {
                case "-1":
                this.activeDataSource = null;
                break;

                case "0":
                if (this.salesInvoiceLineDataSource == null) {
                    this.salesInvoiceLineDataSource = new SalesInvoiceLineReconciliationDataSource();
                    this.salesInvoiceLineDataSource.initWithTableView(this.tableView, this.invoiceHeaderTemplate, this);
                }
                this.activeDataSource = this.salesInvoiceLineDataSource;
                break;

                case "1":
                if (this.purchaseInvoiceLineDataSource == null) {
                    this.purchaseInvoiceLineDataSource = new PurchaseInvoiceLineReconciliationDataSource();
                    this.purchaseInvoiceLineDataSource.initWithTableView(this.tableView, this.invoiceHeaderTemplate, this);
                }
                this.activeDataSource = this.purchaseInvoiceLineDataSource;
                break;

                // case "2": ArchivedInvoice break;
                // case "3": ArchivedTicket break;
                // case "4": SupplierNoteLine break;
                // case "5": DeliveryNoteLine break;
                case "6":
                if (this.bankMovementDataSource == null) {
                    this.bankMovementDataSource = new BankMovementReconciliationDataSource();
                    this.bankMovementDataSource.initWithTableView(this.tableView, this.bankHeaderTemplate, this);
                }
                this.activeDataSource = this.bankMovementDataSource;
                break;
            }

            // the bank movements have their own column titles; the concept filter is shared, so the
            // shown field carries what was typed in the other one
            let bank = this.activeDataSource instanceof BankMovementReconciliationDataSource;
            if (bank != this.showingBankColumns) {
                let from = bank ? this.conceptFilterTextField : this.bankConceptFilterTextField;
                let to = bank ? this.bankConceptFilterTextField : this.conceptFilterTextField;
                to.text = from.text;
                this.showingBankColumns = bank;
            }
            if (bank) { MUICoreLayerAddStyle(this.invoiceTitlebar.layer, "hidden"); MUICoreLayerRemoveStyle(this.bankTitlebar.layer, "hidden"); }
            else { MUICoreLayerRemoveStyle(this.invoiceTitlebar.layer, "hidden"); MUICoreLayerAddStyle(this.bankTitlebar.layer, "hidden"); }

            this.reloadActiveDataSource();
        });

        this.statusComboBox = MUIOutlet(this, "status-cb", "MUIComboBox");
        this.statusComboBox.setOnChangeAction(this, function(this:LedgerAccountReconciliationViewController, control:MUIComboBox, value:string){
            this._status_filter = value as ReconciliationStatusFilter;
            this.reloadActiveDataSource();
        });

        this.calendarButton = MUIOutlet(this, "calendar-btn", "MUIButton");
        this.calendarButton.setAction(this, function(){
            AppHelper.sharedInstance().presentDateSelectionViewController(null, this);
        });

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(DBHelper, DBHelper.saveMainContext);

        this.conceptFilterTextField = MUIOutlet(this, "concept-hover-filter", "ColumnFilterTextField");
        this.conceptFilterTextField.filterController = this.columnFilterController;
        this.conceptFilterTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "concept", null, null);

        this.bankConceptFilterTextField = MUIOutlet(this, "bank-concept-hover-filter", "ColumnFilterTextField");
        this.bankConceptFilterTextField.filterController = this.columnFilterController;
        this.bankConceptFilterTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "concept", null, null);

        this.invoiceTitlebar = MUIOutlet(this, "invoice-titlebar", "MUIView");
        this.bankTitlebar = MUIOutlet(this, "bank-titlebar", "MUIView");

        this.tableView = MUIOutlet(this,"table-view", "UITableView");
        this.invoiceHeaderTemplate = MUIOutlet(this, "invoice-header-view", "InvoiceSectionReconciliationHeader");
        this.bankHeaderTemplate = MUIOutlet(this, "bank-header-view", "BankAccountReconciliationHeader");

        this.accountingEntryContainer = MUIOutlet(this, "accounting-entries-container", "MUIView");

        this.accountingEntryViewController = AccountingEntryViewController.newInstance();
        this.addChildViewController(this.accountingEntryViewController);
        this.accountingEntryContainer.addSubview(this.accountingEntryViewController.view);
        this.showAccountingEntryPanel(false);

        // the list follows what the panel does with the entries (generate, lock, unlock, discard)
        MIONotificationCenter.defaultCenter().addObserver(this, ReconciliationEntryStateHelper.didChangeNotification, function(this:LedgerAccountReconciliationViewController, note:MIONotification){
            let item = note.object as CoreAccounting;
            if (item != null) this.activeDataSource?.refreshItem(item);
        });

        let today = MIODateToday();
        this._from_date_str = MIODateGetDateString(today) + " 00:00:00";
        this._to_date_str = MIODateGetDateString(today) + " 23:59:59";
    }

    private showAccountingEntryPanel(show:boolean) {
        this.accountingEntryViewController.view.hidden = !show;
    }

    private reloadActiveDataSource() {
        // Any reload clears the current selection, so hide the entries panel until a new row is selected
        this.selectedItem = null;
        this.showAccountingEntryPanel(false);

        if (this.activeDataSource == null) {
            this.tableView.dataSource = null;
            this.tableView.delegate = null;
            this.tableView.reloadData();
            return;
        }

        let filterFormat = this.columnFilterController.filterPredicateFormat();
        this.activeDataSource.reloadData(this._from_date_str, this._to_date_str, this._status_filter, filterFormat);
    }

    didSelectItem(item:CoreAccounting, lines?:CoreAccounting[]) {
        this.selectedItem = item;
        if (item == null) {
            this.showAccountingEntryPanel(false);
            return;
        }
        this.showAccountingEntryPanel(true);
        // an invoice's lines may carry entries booked one by one
        this.accountingEntryViewController.setItem(item, lines ?? []);
    }

    // a ledger account or classification changed in the list: the panel saves it and offers to
    // generate the draft entry again
    itemAccountsDidChange(item:CoreAccounting) {
        this.accountingEntryViewController.accountsDidChangeForItem(item);
    }

    datesDidSelect(dateTimeFrom:Date, dateTimeTo:Date) {
        let sdtf = (MUIWebApplication.sharedInstance().delegate as AppDelegate).serverDateTimeFormatter;

        this._from_date_str = sdtf.stringForObjectValue(dateTimeFrom);
        this._to_date_str = sdtf.stringForObjectValue(dateTimeTo);

        this.reloadActiveDataSource();
    }

    filterPredicateDidChange(controller:ColumnFilterController){
        this.reloadActiveDataSource();
    }


}